// Client marketing sites served from this deployment under their own custom
// domains. Middleware resolves the incoming Host header against this registry
// and rewrites the request to the site's route under /sites/<id>, so e.g.
// thebirchcoffeeco.com invisibly serves src/app/sites/birch/. Requests on
// family-apps' own domains (and localhost) fall through to the normal app —
// /sites/<id> stays directly reachable there for previewing.
//
// Adding a client site: add an entry here, create src/app/sites/<id>/, put its
// static assets under public/sites/<id>/, and add the domain(s) to the Vercel
// project.

export interface ClientSite {
  id: string
  hosts: string[]
}

export const CLIENT_SITES: ClientSite[] = [
  {
    id: 'birch',
    hosts: [
      'thebirchcoffeeco.com',
      'www.thebirchcoffeeco.com',
      'thebirchcoffeecompany.com',
      'www.thebirchcoffeecompany.com',
    ],
  },
]

export function resolveClientSiteId(host: string | null): string | null {
  if (!host) return null
  const hostname = host.toLowerCase().split(':')[0]
  for (const site of CLIENT_SITES) {
    if (site.hosts.includes(hostname)) return site.id
  }
  return null
}

export function clientSitePath(siteId: string, pathname: string): string {
  const base = `/sites/${siteId}`
  if (pathname === base || pathname.startsWith(`${base}/`)) return pathname
  return pathname === '/' ? base : `${base}${pathname}`
}
